// extracted by mini-css-extract-plugin
module.exports = {"container":"benefits-module--container--2TYhd","heading":"benefits-module--heading--4vgUL","text":"benefits-module--text--2rpKs","action":"benefits-module--action--3xYoq"};